import { CustomTableSortItems } from 'commons/components/table/sort/custom-table-sorting.model';
import { appRoles } from 'core/constants/constants';

export const USER_LOCATION_ASSIGNMENT_I18N_PREFIX = 'modules.settings.pods.settings-user-location-assignment';

export const DEFAULT_SORT: CustomTableSortItems = { displayName: 'asc' };

/**
 * Role identifiers we have a label for. The contract declares `roles` as a bare string array with no
 * enum, and the upstream schema examples disagree on casing, so anything unlisted is labelled as
 * unknown rather than printed raw into an admin-facing column.
 */
export const ROLE_LABEL_KEYS: Record<string, string> = {
    [appRoles.POCC_ADMIN]: 'admin',
    [appRoles.POCC]: 'pocc',
};
